(function ($) {
  DJ.addBehavior('datepickerRangeInit', '.datepicker-range', {
    attach: function () {
      const datepickerWrapper = this;
      const datepicker = datepickerWrapper.querySelector('.datepicker-range__dates');
      const drupalInputStart = datepickerWrapper.querySelector('.js-form-item-event-starting-date input');
      const drupalInputEnd = datepickerWrapper.querySelector('.js-form-item-event-ending-date input');
      const datepickerFormat = 'DD/MM/YYYY';
      const drupalDatepickerFormat = 'MM/DD/YYYY';
      let drupalStartDate = $(drupalInputStart).val();
      let drupalEndDate = $(drupalInputEnd).val();

      $(datepicker).daterangepicker({
        autoApply: true,
        autoUpdateInput: false,
        locale: {
          daysOfWeek: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
          ],
          monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ],
          firstDay: 1
        },
      });

      if (drupalStartDate && drupalEndDate) {
        drupalStartDate = moment(drupalStartDate, drupalDatepickerFormat);
        drupalEndDate = moment(drupalEndDate, drupalDatepickerFormat);
        $(datepicker).data('daterangepicker').setStartDate(drupalStartDate);
        $(datepicker).data('daterangepicker').setEndDate(drupalEndDate);
        $(datepicker).val(`From ${drupalStartDate.format(datepickerFormat)} to ${drupalEndDate.format(datepickerFormat)}`);
      }

      $(datepicker).on('apply.daterangepicker', (ev, picker) => {
        $(datepicker).val(`From ${picker.startDate.format(datepickerFormat)} to ${picker.endDate.format(datepickerFormat)}`);
        $(drupalInputStart).val(picker.startDate.format(drupalDatepickerFormat));
        $(drupalInputEnd).val(picker.endDate.format(drupalDatepickerFormat));
      });
    }
  });
})(jQuery);
